import AppRoutes from "./routes.jsx";

export default function App() {
  return <AppRoutes />;
}